import type { Device } from '@studio/models/device';
import { useWiring } from './wiring.js';
import { useListener as useListener_ } from '#~/command/hooks.js';

/**
 * Keyboard movement listener.
 *
 * @param deviceId - ID of the device to be controlled.
 */
export const useListener = (deviceId: Device['id']): void => {
  const wiring = useWiring(deviceId);

  useListener_(({ command }) => {
    wiring.listen(command);
  });
};
